<template>
  <section class="contact">
    <div class="inner cg">
      <div class="left">
        <div class="shape i1"/>
        <div class="shape i2"/>
        <h1>Contact Us</h1>
        <p>
          Find your ideal solution with the help of our team of 
          experts and get personalized advice based on your specific needs.
        </p>
      </div>
      <div class="right">
        <div class="shape i3"/>
        <contact-form :modal="modal"/>
      </div>
    </div>
  </section>
</template>

<script>
import ContactForm from './contact';

export default {
  components: { ContactForm },
  props: {
    modal: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/mixins.scss';

.contact {
  position: relative;

  @include desktop {
    padding: 120px 0;
    background: linear-gradient(to right, #3785ac 0%, #3785ac 50%, #f9f9f9 50%);
  }
}

.inner {
  @include desktop {
    display: flex;
  }
}

.left {
  color: #fff;

  @include mobile {
    background-color: #3785ac;
  }
  
  h1 {
    color: inherit;
  }

  p {
    @include desktop {
      margin-top: 80px;
    }
  }

  @include desktop {
    padding-right: 115px;
  }
}

.right {
  background: #f9f9f9;

  @include desktop {
    padding-left: 115px;
  }
}

.left,
.right {
  @include desktop {
    width: 50%;
  }

  @include mobile {
    padding: 60px 20px;
    margin: 0 -20px;
  }
}

.shape {
  position: absolute;

  &.i1 {
    background: url('../assets/nav.png') no-repeat center;
    background-size: contain;
    width: 42px;
    height: 36px;
    transform: rotate(-90deg);

    @include mobile {
      display: none;
    }

    @include desktop {
      top: 40px;
      left: calc(50% - 500px);
    }
  }
  
  &.i2 {
    background: url('../assets/nav.png') no-repeat center;
    background-size: contain;
    width: 51px;
    height: 59px;

    @include mobile {
      display: none;
    }

    @include desktop {
      bottom: 90px;
      left: calc(50% - 200px);
    }
  }
  
  &.i3 {
    background: url('../assets/footer-shape.png') no-repeat center;
    background-size: contain;
    width: 85px;
    height: 97px;

    @include mobile {
      display: none;
    }

    @include desktop {
      top: 30px;
      left: calc(50% + 320px);
      transform: rotate(120deg);
    }
  }
}
</style>